export default __webpack_public_path__ + "static/media/confirm-icon-white.0b6aab7d.svg";